import { useEffect, useState } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useCustomerProfileForm } from './useCustomerProfileForm';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Box } from '@uhg-abyss/web/ui/Box';
import {
  getVersionListBySubmitterGroupName,
  encryptProfileParams,
  decryptProfileParams,
} from '@src/utils';
import { useSelector } from 'react-redux';

const SearchBar = ({ isSearch }) => {
  const router = useRouter();
  const {
    data,
    form,
    errMsg,
    search,
    demList,
    setSearch,
    demIndex,
    setDemIndex,
    setDemList,
    onVersionChange,
    setIsSearchEnabled,
    isSearchEnabled,
    submitterList,
    editMode,
    submitterDetails,
    fetchDataBysearch,
    updateSubmitterDeatils,
    fetchProfileBySumbitterChange,
    submitterValue,
    setSubmitterValue,
    vNumber,
    setVNumber,
    vlist,
    loadStatus,
    setVlist,
    setFieldErrorMessages,
    handleEditButton,
  } = useCustomerProfileForm();

  const { encryptedData: profileEncryptedData } = router.getRouteParams();
  const { version, asgnId, srchDestSysCd } = profileEncryptedData
    ? decryptProfileParams(profileEncryptedData)
    : { version: undefined, asgnId: undefined, srchDestSysCd: undefined };

  const handleVersionChange = (vernumber) => {
    if (isSearchEnabled) {
      onVersionChange(vernumber);
    } else {
      router.navigate(
        `/profile/${encryptProfileParams(vernumber, asgnId, srchDestSysCd)}`
      );
      onVersionChange(vernumber);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setDemList([]);
  };

  const performSearch = () => {
    if (search !== '') {
      router.navigate(`/profile/search`);
      setFieldErrorMessages([]);
      setIsSearchEnabled(true);
      fetchDataBysearch(search);
    }
  };
  const history = useSelector((state) => state?.listOfValues?.versions);
  const handleSubmissionGroup = (id: string) => {
    setDemIndex(id);
    setSubmitterValue(id);
    const selectedSubmitter = history.find(
      (item) => item?.submitterGroupName === id
    );

    if (!selectedSubmitter) {
      return;
    }

    setVlist(selectedSubmitter?.versions);
    setVNumber(selectedSubmitter?.versions[0]?.versionNumber);
    const {
      submitterAssignId,
      submitterGroupId,
      submitterGroupName,
      destinationSystem,
    } = selectedSubmitter;
    updateSubmitterDeatils({
      submitterAssignId: submitterAssignId,
      submitterGroupId: submitterGroupId,
      submitterGroupName: submitterGroupName,
      destinationSystem: destinationSystem,
    });
    fetchProfileBySumbitterChange({
      submitterAssignId: submitterAssignId,
      submitterGroupId: submitterGroupId,
      submitterGroupName: submitterGroupName,
      destinationSystem: destinationSystem,
    });
  };
  const handleKeyPress = (event) => {
    if (event?.key === 'Enter') {
      performSearch();
    }
  };
  return (
    <Layout.Group
      css={{
        justifyContent: editMode ? 'flex-start' : 'space-between',
      }}
    >
      {editMode ? null : (
        <Layout.Stack>
          <Layout.Group
            css={{
              marginLeft: '10px',
            }}
          >
            <span>
              <strong>Search For:</strong>
            </span>
            <TextInput
              label=""
              placeholder=""
              value={search}
              isClearable
              onChange={handleSearch}
              onKeyDown={handleKeyPress}
              onClear={() => setSearch('')}
            />
            <Button
              css={{ marginTop: '8px', marginLeft: '25px' }}
              size="$md"
              onClick={performSearch}
            >
              Find
            </Button>
          </Layout.Group>
        </Layout.Stack>
      )}

      <Layout.Stack>
        <Layout.Group>
          {isSearchEnabled && submitterList?.length > 1 && (
            <>
              <strong>Submission Group: </strong>
              <SelectInput
                isDisabled={editMode}
                label=""
                //placeholder={submitterValue}
                value={submitterValue}
                onChange={(submitterValue) =>
                  handleSubmissionGroup(submitterValue)
                }
                isClearable
                options={submitterList?.map((x, index) => ({
                  ...x,
                  label: `${x?.submitterAssignId} - ${x?.submitterGroupName}`,
                  value: x?.submitterGroupName,
                }))}
                isRequired
                css={{
                  'abyss-select-input-wrapper': {
                    flexDirection: 'row',
                  },
                }}
              />
            </>
          )}
        </Layout.Group>
      </Layout.Stack>

      {((version && asgnId && srchDestSysCd) ||
        submitterList?.length === 1 ||
        !data) && (
        <span style={{ marginRight: '95px' }}>
          <strong>Submission Group: </strong>
          {data
            ? `${submitterList[0]?.submitterAssignId} - ${submitterList[0]?.submitterGroupName}`
            : errMsg}
        </span>
      )}
      {((isSearchEnabled && vlist?.length > 0) ||
        (version && asgnId && srchDestSysCd)) &&
        (loadStatus ? (
          'loading'
        ) : (
          <Layout.Group
            css={{
              marginLeft: editMode ? '750px' : '',
              marginRight: '10px',
              // v2 SelectInput stacks its label/required-* above the input
              // (wrapper is flexDirection:column). Lay the (empty) label and the
              // dropdown out inline so the required "*" sits beside the control.
              '.abyss-select-input-wrapper': {
                flexDirection: 'row',
                alignItems: 'center',
                gap: '4px',
              },
              '.abyss-select-input-root .abyss-label-container': {
                width: 'auto',
              },
            }}
          >
            <span>
              <strong> Version:</strong>
            </span>
            {editMode ? (
              <Box
                color="$web.semantic.color.surface.container.primary"
                css={{
                  'abyss-box-root': {
                    color: '$web.semantic.color.text.content.primary-alt',
                  },
                }}
              >
                {vNumber}
              </Box>
            ) : (
              <SelectInput
                label=""
                width={'90px'}
                value={+vNumber}
                onChange={handleVersionChange}
                options={
                  vlist &&
                  vlist?.map((item) => ({
                    ...item,
                    value: item?.versionNumber,
                    label: item?.versionNumber,
                  }))
                }
                isRequired
              />
            )}
          </Layout.Group>
        ))}
    </Layout.Group>
  );
};

export default SearchBar;
